/**
 * AYARLAR KART DÜZENİ (Gelen kararlar 01.11.2026): kartlar sabit genişlikte,
 * ekrana sığdığı kadar sütunda; her kart sırası gelince EN KISA sütunun
 * altına yerleşir, kartlar arasında dikey boşluk kalmaz. Bir kart uzayınca
 * yalnızca aynı sütundaki alttaki kartlar kayar: sütun ataması yalnızca
 * sütun ya da kart sayısı değişince yeniden yapılır. İki kart yan yana
 * sığmıyorsa (telefon) tek sütun.
 */

/** Kart genişliği (px): içindeki en geniş form alanı (24rem) + iç boşluk. */
export const KART_PX = 416;
/** Kartlar arası boşluk (px), yatay ve dikey. */
export const ARALIK_PX = 16;

/** Genişliğe sığan sütun sayısı (en az 1). */
export function sutunSayisi(genislik: number, kart = KART_PX, aralik = ARALIK_PX): number {
  if (!(genislik > 0)) return 1;
  return Math.max(1, Math.floor((genislik + aralik) / (kart + aralik)));
}

/** Kartları sırayla en kısa sütuna atar (eşitlikte soldaki); kart başına sütun numarası. */
export function sutunAta(yukseklikler: readonly number[], sutun: number, aralik = ARALIK_PX): number[] {
  const boy = new Array<number>(Math.max(1, sutun)).fill(0);
  return yukseklikler.map((h) => {
    let en = 0;
    for (let c = 1; c < boy.length; c++) if (boy[c]! < boy[en]!) en = c;
    boy[en] = boy[en]! + h + aralik;
    return en;
  });
}

export interface SutunKonumu {
  readonly sol: number;
  readonly ust: number;
}

/** Sabit atamayla konumlar: sütundaki önceki kartların boyu + aralık. Toplam yükseklik en uzun sütun. */
export function konumlar(
  atama: readonly number[],
  yukseklikler: readonly number[],
  kart = KART_PX,
  aralik = ARALIK_PX,
): { readonly yerler: SutunKonumu[]; readonly yukseklik: number } {
  const boy: number[] = [];
  const yerler = atama.map((c, i) => {
    const ust = boy[c] ?? 0;
    boy[c] = ust + (yukseklikler[i] ?? 0) + aralik;
    return { sol: c * (kart + aralik), ust };
  });
  return { yerler, yukseklik: Math.max(0, ...boy.map((b) => b - aralik)) };
}
